module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"error":{"fetch_documents":"ドキュメントの取得に失敗しました","fetch_announcements":"お知らせの取得に失敗しました"}},"en":{"error":{"fetch_documents":"Failed to fetch documents","fetch_announcements":"Failed to fetch announcements"}}}')
  delete Component.options._Ctor
}
